import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
/**
 * Clase para definir funciones y propiedades de forma global, es decir, para ser utilizada en las demas clases
 */
@Injectable({
  providedIn: 'root',
})
export class Setting {
  /**
   * Url de la API que utiliza la aplicacion para consultar las distintas inforamciones de los widgets
   */
  APIEndPoint: string = environment.APIEndPoint;
  BaseAPIUrl: string = this.APIEndPoint;

  /**
   * Nest API
   * */

  /**
   * Endpoints pre-definidos
   */
  Endpoint = {
    Login: `${this.APIEndPoint}/auth`,
    SignUp: `${this.BaseAPIUrl}/sign-up`,
    Users: `${this.BaseAPIUrl}/user`,
    UsersWithOrganization: `${this.BaseAPIUrl}/user/with-organization`,
    UserByAccess: `${this.BaseAPIUrl}/UserByAccess`,
    Organizations: `${this.BaseAPIUrl}/organization`,
    Contacts: `${this.BaseAPIUrl}/contact`,
    ContactsImportCsv: `${this.BaseAPIUrl}/contact/import/csv`,
    ContactsImportCsvTemplate: `${this.BaseAPIUrl}/contact/import/csv/template`,
    ContactAddressesImportCsv: `${this.BaseAPIUrl}/contact-addresses/import/csv`,
    ContactAddressesImportCsvTemplate: `${this.BaseAPIUrl}/contact-addresses/import/csv/template`,
    EntityType: `${this.BaseAPIUrl}/entity-types`,
    ListOfValues: `${this.BaseAPIUrl}/list-of-values`,
    Services: `${this.BaseAPIUrl}/services`,
    Products: `${this.BaseAPIUrl}/products`,
    Invoices: `${this.BaseAPIUrl}/invoices`,
    Alerts: `${this.BaseAPIUrl}/alerts`,
    Ecf: `${this.BaseAPIUrl}/ecf`,
    SystemPreferences: `${this.BaseAPIUrl}/system-preferences`,
    CustomFields: `${this.BaseAPIUrl}/custom-fields`,
    CustomFieldsByRole: `${this.BaseAPIUrl}/custom-fields/by-role`,
    CustomFieldSections: `${this.BaseAPIUrl}/custom-field-sections`,
    Notes: `${this.BaseAPIUrl}/notes`,
    Prospects: `${this.BaseAPIUrl}/v1/Prospects`,
    CreateProspect: `${this.BaseAPIUrl}/v1/CreateProspects`,
    DelProspect: `${this.BaseAPIUrl}/v1/DelProspects`,
    FilterProspects: `${this.BaseAPIUrl}/v1/rest`,
    Views: `${this.BaseAPIUrl}/Views`,
    Roles: `${this.BaseAPIUrl}/role`,
    Access: `${this.BaseAPIUrl}/role/access`,
    RemoveRoleAccess: `${this.BaseAPIUrl}/RemoveRoleAccess`,
    RolesAccess: `${this.BaseAPIUrl}/RolesAccess`,
    UsersRoles: `${this.BaseAPIUrl}/UsersRoles`,
    RemoveUserFromRole: `${this.BaseAPIUrl}/RemoveUserFromRole`,
    getPickList: `${this.APIEndPoint}/getPickList`,
    Logs: `${this.APIEndPoint}/api/Logs`,
    LogsByCompId: `${this.APIEndPoint}/LogsByCompId`,
    LogsUsers: `${this.APIEndPoint}/LogsUsers`,
    Contracts: `${this.BaseAPIUrl}/contracts`,
    Enrollments: `${this.BaseAPIUrl}/enrollments`,
    ContractItemsBulk: `${this.BaseAPIUrl}/contract-items/bulk`,
    EducationStudentsWithParents: `${this.BaseAPIUrl}/education/students-with-parents`,
    SalesForceObj: `${this.BaseAPIUrl}/v1/getObjectData`,
    getObjectDataMultiFilter: `${this.BaseAPIUrl}/v1/getObjectDataMultiFilter`,
    AuditLogs: `${this.BaseAPIUrl}/audit-logs`,
    VoiceTranscription: `${this.APIEndPoint}/ia-voz/transcribe`,
    VoiceTranscriptionBatch: `${this.APIEndPoint}/ia-voz/transcribe/batch`,
    S3Files: `${this.BaseAPIUrl}/s3-files`,
    CallScripts: `${this.BaseAPIUrl}/call-scripts`,
    OrganizationApiKeys: `${this.BaseAPIUrl}/organization-api-keys`,
    OrgModulesAdmin: `${this.BaseAPIUrl}/org-modules`,
    Scheduler: `${this.BaseAPIUrl}/scheduler`,
  };

  /**
   * Endpoints pre-definidos para la API de Nest
   * relacionados a la conversion de leads a cuentas/programas
   * */

  /**
   * Global http options
   */
  HttpOptions = {
    headers: new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded'
    }),
  };
  /**
   * TimeOut general pre-definido
   */
  GlobalTimeOut: number = 30000;
}
